import { apiClient } from '../config/api';

// FEAT-044 (MVP-8.10a, MVP-18.31): client for the Safety Contacts API.
// The API never throws on a zip miss — it returns a neutral 211 fallback so
// the UI can render a calm message instead of an error.

export interface SafetyContactRow {
  zip: string;
  nonEmergencyPolice: string;
  aps: string;
  regionalNotes: string | null;
  updatedAt: string;
}

export interface SafetyContactsFallback {
  fallback: true;
  source: 'national';
  number: '211';
  description: 'United Way 211';
}

export interface SafetyContactHit {
  fallback: false;
  contact: SafetyContactRow;
}

export type SafetyContactsLookupResponse = SafetyContactHit | SafetyContactsFallback;

export const SAFETY_CONTACTS_FALLBACK: SafetyContactsFallback = {
  fallback: true,
  source: 'national',
  number: '211',
  description: 'United Way 211',
};

class SafetyContactsService {
  async lookupByZip(zip: string): Promise<SafetyContactsLookupResponse> {
    const trimmed = zip.trim();
    const response = await apiClient.get<SafetyContactsLookupResponse>(
      `/safety-contacts?zip=${encodeURIComponent(trimmed)}`
    );
    return response.data;
  }
}

export const safetyContactsService = new SafetyContactsService();
